import Loading from "../../../../../src/components/overlay/desktop/Loading";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Loading,
  Playground,
  Props,
  React
};